(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ReportingAreaActivityController', ReportingAreaActivityController);

    ReportingAreaActivityController.$inject = ['ReportingAreaActivity', 'AlertService', '$translate'];

    function ReportingAreaActivityController(ReportingAreaActivity, AlertService, $translate) {
        var vm = this;

        vm.loading = true;
        vm.filterOptionsReady = false;
        vm.hasLoadedData = false;
        vm.reporting = null;
        vm.areas = [];
        vm.agencyOptions = [];
        vm.agencyFilters = {};
        vm.visibleAreas = [];
        vm.areaOptions = [];
        vm.areaFilters = {};
        vm.sortedAreas = [];
        vm.kpis = [];
        vm.visibleKpis = [];
        vm.kpiGroups = [];
        vm.visibleKpiGroups = [];
        vm.groupOptions = [];
        vm.groupFilters = {};
        vm.filtersCollapsed = false;
        vm.sortKey = 'areaName';
        vm.sortDescending = false;
        vm.applyFilters = applyFilters;
        vm.downloadJson = downloadJson;
        vm.getSortIcon = getSortIcon;
        vm.hasSelectedAreas = hasSelectedAreas;
        vm.onAgencyFilterChanged = onAgencyFilterChanged;
        vm.onAreaFilterChanged = onAreaFilterChanged;
        vm.refreshView = refreshView;
        vm.sortBy = sortBy;
        vm.toggleFilters = toggleFilters;

        loadFilters();

        function loadFilters() {
            vm.loading = true;
            vm.kpis = buildKpiDefinitions();
            vm.kpiGroups = buildKpiGroups(vm.kpis);
            ReportingAreaActivity.getFilters(onFiltersSuccess, onError);
        }

        function onFiltersSuccess(data) {
            vm.filterOptionsReady = true;
            initializeFilters(data);
            vm.loading = false;
        }

        function onSuccess(data) {
            vm.reporting = data;
            vm.areas = (data.areas || []).map(enrichArea);
            refreshView();
            vm.hasLoadedData = true;
            vm.loading = false;
        }

        function onError(error) {
            vm.loading = false;
            AlertService.error(error && error.data && error.data.message ? error.data.message : 'Unable to load reporting.');
        }

        function enrichArea(area) {
            area.contractsPerCollector = buildWorkload(area.latestKnownActiveContracts, area.latestKnownCollectors);
            area.contractsPerReader = buildWorkload(area.latestKnownActiveContracts, area.latestKnownReaders);
            area.cells = buildCells(area);
            return area;
        }

        function buildKpiGroups(kpis) {
            var groups = [];
            angular.forEach(kpis, function(kpi) {
                var lastGroup = groups.length ? groups[groups.length - 1] : null;
                if (!lastGroup || lastGroup.key !== kpi.groupKey) {
                    groups.push({
                        key: kpi.groupKey,
                        label: kpi.groupLabel,
                        span: 1
                    });
                } else {
                    lastGroup.span += 1;
                }
            });
            return groups;
        }

        function buildKpiDefinitions() {
            return [
                metric('contractsOpened', 'contractsOpened', 'contracts'),
                metric('contractsClosed', 'contractsClosed', 'contracts'),
                metric('meterReadingForms', 'meterReadingForms', 'meterReading'),
                metric('metersToRead', 'metersToRead', 'meterReading'),
                metric('metersRead', 'metersRead', 'meterReading'),
                metric('metersNotRead', 'metersNotRead', 'meterReading'),
                metric('metersWithPhoto', 'metersWithPhoto', 'meterReading'),
                metric('collectionLists', 'collectionLists', 'payments'),
                metric('contractsToCollect', 'contractsToCollect', 'payments'),
                metric('collectedContracts', 'collectedContracts', 'payments'),
                metric('collectionPayments', 'collectionPayments', 'payments'),
                metric('collectionPaymentsWithSignature', 'collectionPaymentsWithSignature', 'payments'),
                metric('agencyCollections', 'agencyCollections', 'payments'),
                metric('mobileMoneyCollections', 'mobileMoneyCollections', 'payments'),
                metric('quotesCreated', 'quotesCreated', 'billing'),
                metric('quotesTransformedToSale', 'quotesTransformedToSale', 'billing'),
                metric('invoicesGenerated', 'invoicesGenerated', 'billing'),
                metric('paymentRecoveryNotices', 'paymentRecoveryNotices', 'billing'),
                metric('refunds', 'refunds', 'financialAdjustment'),
                metric('paymentCorrections', 'paymentCorrections', 'financialAdjustment'),
                metric('avoirs', 'avoirs', 'financialAdjustment'),
                metric('creditNotes', 'creditNotes', 'financialAdjustment'),
                metric('debtWaivers', 'debtWaivers', 'financialAdjustment'),
                metric('windfallGains', 'windfallGains', 'financialAdjustment'),
                metric('calendarEventsCreated', 'calendarEventsCreated', 'teamwork'),
                metric('eventFormsCreated', 'eventFormsCreated', 'teamwork'),
                metric('automationMessages', 'automationMessages', 'communication'),
                metric('campaignMessages', 'campaignMessages', 'communication'),
                metric('clientPortalPageViews', 'clientPortalPageViews', 'clientPortal'),
                metric('clientPortalUniqueUsers', 'clientPortalUniqueUsers', 'clientPortal'),
                metric('clientPortalEmailLogins', 'clientPortalEmailLogins', 'clientPortal'),
                metric('clientPortalSmsLogins', 'clientPortalSmsLogins', 'clientPortal'),
                metric('clientPortalLostPasswords', 'clientPortalLostPasswords', 'clientPortal')
            ];

            function metric(key, field, groupKey) {
                return {
                    key: key,
                    field: field,
                    label: $translate.instant('wamasysApp.reportingAreaActivity.metrics.' + key),
                    groupKey: groupKey,
                    groupLabel: $translate.instant('wamasysApp.reportingAreaActivity.groups.' + groupKey)
                };
            }
        }

        function buildCells(area) {
            var months = area.months || [];
            var activeContracts = area.latestKnownActiveContracts;

            return vm.kpis.map(function(definition) {
                var values = months.map(function(month) {
                    return safeLong(month[definition.field]);
                });
                var latest = values.length ? values[values.length - 1] : 0;
                var total = values.reduce(function(sum, value) {
                    return sum + value;
                }, 0);
                var ratio = buildPerContractRatio(total, activeContracts);

                return {
                    key: definition.key,
                    label: definition.label,
                    latest: latest,
                    ratio: ratio,
                    total: total,
                    tooltip: buildTooltip(total, ratio, activeContracts),
                    sparkline: buildSparkline(months, definition.field)
                };
            });
        }

        function initializeFilters(filters) {
            vm.agencyFilters = {};
            vm.areaFilters = {};
            vm.groupFilters = {};
            vm.agencyOptions = (filters && filters.agencies ? filters.agencies : []).slice().sort(function(left, right) {
                return compareText(left.name, right.name);
            });
            vm.areaOptions = (filters && filters.areas ? filters.areas : []).slice().sort(function(left, right) {
                return compareText(left.name, right.name);
            });
            vm.groupOptions = vm.kpiGroups.map(function(group) {
                return {
                    key: group.key,
                    label: group.label
                };
            });

            angular.forEach(vm.agencyOptions, function(option) {
                vm.agencyFilters[option.id] = false;
            });
            angular.forEach(vm.areaOptions, function(option) {
                vm.areaFilters[option.id] = false;
            });
            angular.forEach(vm.groupOptions, function(option) {
                vm.groupFilters[option.key] = true;
            });
        }

        function buildSparkline(months, field) {
            var values = (months || []).map(function(month) {
                return safeLong(month[field]);
            });

            if (!values || !values.length) {
                return null;
            }

            var width = 108;
            var height = 28;
            var padding = 4;
            var max = Math.max.apply(null, values.concat([0]));
            var min = Math.min.apply(null, values.concat([0]));
            var range = max - min;

            var points = values.map(function(value, index) {
                var x = values.length === 1 ? width / 2 : padding + (index * (width - (padding * 2)) / (values.length - 1));
                var y = range === 0 ? height / 2 : height - padding - (((value - min) / range) * (height - (padding * 2)));
                var monthLabel = months[index] && months[index].month ? months[index].month : String(index + 1);
                return {
                    x: x,
                    y: y,
                    value: value,
                    title: monthLabel + ' : ' + value
                };
            });

            return {
                width: width,
                height: height,
                polylinePoints: points.map(function(point) {
                    return point.x.toFixed(2) + ',' + point.y.toFixed(2);
                }).join(' '),
                points: points
            };
        }

        function safeLong(value) {
            return value || 0;
        }

        function buildWorkload(activeContracts, headcount) {
            var contracts = safeLong(activeContracts);
            var people = safeLong(headcount);
            if (!people) {
                return null;
            }
            return contracts / people;
        }

        function buildPerContractRatio(totalValue, activeContracts) {
            var contracts = safeLong(activeContracts);
            if (!contracts) {
                return null;
            }
            return totalValue / contracts;
        }

        function formatPerContractRatio(ratio) {
            if (ratio === null) {
                return '-';
            }
            return ratio.toFixed(2) + ' / ' + $translate.instant('wamasysApp.reportingAreaActivity.table.contract');
        }

        function buildTooltip(totalValue, ratio, activeContracts) {
            return $translate.instant('wamasysApp.reportingAreaActivity.table.ratioTooltip', {
                totalValue: totalValue || 0,
                ratioValue: formatPerContractRatio(ratio),
                activeContracts: activeContracts || 0
            });
        }

        function hasSelectedAreas() {
            return vm.areaOptions.some(function(option) {
                return vm.areaFilters[option.id] === true;
            });
        }

        function onAgencyFilterChanged(agencyId) {
            var isSelected = vm.agencyFilters[agencyId] === true;
            angular.forEach(vm.areaOptions, function(option) {
                if (option.agencyId === agencyId) {
                    vm.areaFilters[option.id] = isSelected;
                }
            });
        }

        function onAreaFilterChanged(areaId) {
            var areaOption = null;
            angular.forEach(vm.areaOptions, function(option) {
                if (option.id === areaId) {
                    areaOption = option;
                }
            });

            if (!areaOption) {
                return;
            }

            var hasSelectedAreaForAgency = vm.areaOptions.some(function(option) {
                return option.agencyId === areaOption.agencyId && vm.areaFilters[option.id] === true;
            });
            vm.agencyFilters[areaOption.agencyId] = hasSelectedAreaForAgency;
        }

        function applyFilters() {
            var request = buildRequestParameters();
            if (!request.areaIds) {
                vm.reporting = null;
                vm.areas = [];
                vm.visibleAreas = [];
                vm.sortedAreas = [];
                vm.hasLoadedData = false;
                AlertService.error($translate.instant('wamasysApp.reportingAreaActivity.home.selectionRequired'));
                return;
            }

            vm.loading = true;
            ReportingAreaActivity.get(request, onSuccess, onError);
        }

        function buildRequestParameters() {
            var selectedAreaIds = vm.areaOptions.filter(function(option) {
                return vm.areaFilters[option.id] === true;
            }).map(function(option) {
                return option.id;
            });
            var selectedGroupKeys = vm.groupOptions.filter(function(option) {
                return vm.groupFilters[option.key] !== false;
            }).map(function(option) {
                return option.key;
            });

            return {
                areaIds: selectedAreaIds.join(','),
                groupKeys: selectedGroupKeys.join(',')
            };
        }

        function refreshView() {
            vm.visibleAreas = (vm.areas || []).filter(function(area) {
                if (vm.agencyFilters[area.agencyId || 0] === false) {
                    return false;
                }
                return vm.areaFilters[area.areaId] !== false;
            });
            vm.visibleKpis = (vm.kpis || []).filter(function(kpi) {
                return vm.groupFilters[kpi.groupKey] !== false;
            });
            vm.visibleKpiGroups = buildKpiGroups(vm.visibleKpis);
            angular.forEach(vm.visibleAreas, function(area) {
                area.visibleCells = buildVisibleCells(area);
            });

            if (vm.sortKey !== 'areaName' && !findVisibleKpi(vm.sortKey)) {
                vm.sortKey = 'areaName';
                vm.sortDescending = false;
            }

            applySorting();
        }

        function toggleFilters() {
            vm.filtersCollapsed = !vm.filtersCollapsed;
        }

        function sortBy(kpiKey) {
            if (vm.sortKey === kpiKey) {
                vm.sortDescending = !vm.sortDescending;
            } else {
                vm.sortKey = kpiKey;
                vm.sortDescending = true;
            }
            applySorting();
        }

        function applySorting() {
            vm.sortedAreas = (vm.visibleAreas || []).slice().sort(function(left, right) {
                if (vm.sortKey === 'areaName') {
                    var nameComparison = compareText(left.areaName, right.areaName);
                    return vm.sortDescending ? (nameComparison * -1) : nameComparison;
                }

                var leftValue = getSortValue(left, vm.sortKey);
                var rightValue = getSortValue(right, vm.sortKey);

                if (leftValue === null && rightValue === null) {
                    return compareText(left.areaName, right.areaName);
                }
                if (leftValue === null) {
                    return 1;
                }
                if (rightValue === null) {
                    return -1;
                }
                if (leftValue === rightValue) {
                    return compareText(left.areaName, right.areaName);
                }

                if (vm.sortDescending) {
                    return rightValue > leftValue ? 1 : -1;
                }
                return leftValue > rightValue ? 1 : -1;
            });
        }

        function getSortValue(area, sortKey) {
            if (sortKey === 'areaName') {
                return area.areaName || '';
            }
            var cell = findCell(area, sortKey);
            if (!cell) {
                return null;
            }
            return cell.total || 0;
        }

        function compareText(left, right) {
            left = left || '';
            right = right || '';
            return left.localeCompare(right);
        }

        function findCell(area, key) {
            if (!area || !area.cells) {
                return null;
            }
            for (var index = 0; index < area.cells.length; index++) {
                if (area.cells[index].key === key) {
                    return area.cells[index];
                }
            }
            return null;
        }

        function findVisibleKpi(key) {
            for (var index = 0; index < vm.visibleKpis.length; index++) {
                if (vm.visibleKpis[index].key === key) {
                    return vm.visibleKpis[index];
                }
            }
            return null;
        }

        function buildVisibleCells(area) {
            return vm.visibleKpis.map(function(kpi) {
                return findCell(area, kpi.key);
            }).filter(function(cell) {
                return !!cell;
            });
        }

        function getSortIcon(kpiKey) {
            if (vm.sortKey !== kpiKey) {
                return 'fa-sort';
            }
            return vm.sortDescending ? 'fa-sort-desc' : 'fa-sort-asc';
        }

        function downloadJson() {
            var request = buildRequestParameters();
            if (!request.areaIds) {
                AlertService.error($translate.instant('wamasysApp.reportingAreaActivity.home.selectionRequired'));
                return;
            }

            ReportingAreaActivity.downloadJson(request, function(content) {
                var url = URL.createObjectURL(content.response);
                var link = document.createElement('a');
                link.href = url;
                link.download = content.fileName;
                link.target = '_blank';
                link.click();
            }, onError);
        }
    }
})();
